import { useRef } from "react";
import { NavLink as RouterNavLink, NavLinkProps as RouterNavLinkProps } from "react-router-dom";

import { useSendUserEvent } from "@/hooks/user-event/useSendUserEvent";

export type NavLinkProps = RouterNavLinkProps & React.RefAttributes<HTMLAnchorElement>;

export const NavLink: React.FC<NavLinkProps> = ({ children, ...props }) => {
    const ref = useRef(null);
    const sendUserEvent = useSendUserEvent();

    const handleClick = async (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        if (props?.onClick !== undefined) props.onClick(event);

        const target = props.to;
        let targetPath: string;
        if (typeof target === "string") {
            targetPath = target;
        } else {
            targetPath = target.pathname ?? "";
        }

        sendUserEvent({
            type: "navigation",
            value: targetPath,
        });
    };

    return (
        <RouterNavLink {...props} onClick={handleClick} ref={ref}>
            {children}
        </RouterNavLink>
    );
};
